import React, { useState, useEffect } from "react";
// import '../../styles/Appetizers.css';
import '../../styles/MenuItems.css';
import "../../styles/Styles.css";


function Addons() {

    const [addons, setAddons] = useState([]);

    useEffect(() => {
        fetch('https://strapi.restauracjasamiswoi.pl/api/categories?populate=menu_items')
        .then(response => response.json())
        .then(data => {
            const category = data.data.find(item => item.name === "DODATKI");

            if (category) {
                setAddons(category.menu_items);
            } else {
                console.log('Category not found');
            }
        })
    }, []);

    return (

        <div className="container-fluid">
            <div className="container section-menu-item">
                <div className="dish-photo-container">
                    <img src={require("../../assets/menu/fries.webp")} className="dish-photo-menu img-menu img-rounded shadow" />
                </div>
                <div className="menu-right-55">
                    <p className="menu-item-title-font fs-1 fw-bold">DODATKI</p>
                    <hr/>
                    {addons.map((addon) => (
                        <div key={addon.id} className="container">
                            <div className="dish-name-container d-flex justify-content-between">
                                <p className="menu-item-title-font fs-5 m-0">{addon.name}</p>
                                <p className="fs-5 m-0">{addon.price}zł</p>
                            </div>
                            <p className="ingridients-container fs-6 m-0 fw-lighter">{addon.ingredients}</p>
                            <div className="mb-3 mt-3 divide-line"/>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default Addons;